// Role helpers — separate file to satisfy React Fast Refresh
// (Fast Refresh requires files to only export components, or only non-component exports)
import { useAuth } from './AuthContext'

export function useIsAdmin() {
  const { agent } = useAuth()
  return agent?.role === 'admin'
}

export function useIsSupervisorOrAdmin() {
  const { agent } = useAuth()
  return agent?.role === 'supervisor' || agent?.role === 'admin'
}
